export default __webpack_public_path__ + "static/media/Signal.b1ec8762.svg";